<!-- 任务点排名 -->
<template>
  <div>
    <div ref="wholePage">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-card title="研发任务延期数据" size="small">
            <div id="task-dely" :style="{ height: height, width: width }" />
          </a-card>

        </a-col>
        <a-col :span="12">
          <a-card title="研发任务延期率" size="small">
            <div id="task-dely-rate" :style="{ height: height, width: width }" />
          </a-card>

        </a-col>

      </a-row>
    </div>
    <div v-if="taskList && taskList.length > 0">
      <task-delay-list-modal ref="taskDelayListModal" :task-list="taskList" />
    </div>
  </div>
</template>
<script>
import { getDelayTask } from '@/api/data/task';
import TaskDelayListModal from '@/pages/data/task/components/TaskDelayListModal';
export default {
  components: { TaskDelayListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      data: null,
      seriesIndex: 0,
      taskList: [],
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
        ]
      },
      rate_option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        series: [
        ]
      }
    };
  },
  watch: {
    filterForm() {
      this.getData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/legend');
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/line');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById('task-dely'));
    this.myChart_rate = echarts.init(document.getElementById('task-dely-rate'));
    this.myChart.on('click', param => {
      this.seriesIndex = param.seriesIndex;
    });
    this.myChart.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (this.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = this.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        // const y = param.target.__ec_inner_7.seriesIndex;
        setTimeout(() => {
          this.onDetail(index, this.seriesIndex);
        }, 10); // 延迟 200 毫秒
      }
    });
    this.myChart_rate.on('click', param => {
      this.seriesIndex = param.seriesIndex;
    });
    this.myChart_rate.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (this.myChart_rate.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = this.myChart_rate.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        // const y = param.target.__ec_inner_7.seriesIndex;
        setTimeout(() => {
          this.onDetail(index, this.seriesIndex);
        }, 10); // 延迟 200 毫秒
      }
    });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
      this.myChart_rate.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.myChart_rate.setOption(this.rate_option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
      this.$nextTick(() => {
        this.myChart_rate.resize();
      });
    },
    onDetail(index, y) {
      this.index = index;
      const _time = this.option.xAxis[0].data[index];
      const team = this.option.series.map(item => item.name)[y];

      this.taskList = this.data[team][index].taskList;
      setTimeout(() => {
        this.$refs.taskDelayListModal.open();
      }, 10); // 延迟 200 毫秒
    },
    getData() {
      this.loading = true;
      getDelayTask(this.filterForm)
        .then(res => {
          const items = Object.entries(res.data.result);
          this.data = res.data.result;
          this.option.series = items.map(item => (
            {
              name: item[0],
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series'
              },
              data: item[1].map(item => item.delayNum)
            }));
          this.option.xAxis[0].data = res.data.weeks;
          this.drawChart();

          const rate_items = Object.entries(res.data.result);
          this.rate_option.series = rate_items.map(item => ({
            name: item[0],
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: item[1].map(item => (item.delayNum / item.totalNum)),
            label: {
              formatter: '{c}%'
            }
          }));
          this.rate_option.xAxis[0].data = res.data.weeks;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    close() {
      this.detailVisible = false;
    }
  }
};
</script>

  <style lang="less" scoped>
  .customer-card {
    margin-bottom: 10px;
  }
  </style>

